import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";

export const PageHeader = ({ title, subtitle, back, right, testId }) => {
  const nav = useNavigate();
  return (
    <div className="flex items-start justify-between gap-4 mb-8 mm-fade-up" data-testid={testId || "page-header"}>
      <div className="flex items-start gap-3">
        {back && (
          <button data-testid="page-back-button" onClick={() => nav(-1)} className="mt-1 p-2 rounded-full mm-soft hover:opacity-80 transition-opacity" aria-label="Back">
            <ArrowLeft size={18} />
          </button>
        )}
        <div>
          <h1 className="text-3xl sm:text-4xl font-bold">{title}</h1>
          {subtitle && <p className="text-mm-muted mt-1 text-sm sm:text-base">{subtitle}</p>}
        </div>
      </div>
      {right}
    </div>
  );
};

export const Spinner = ({ className = "" }) => (
  <div className={`flex justify-center py-16 ${className}`} data-testid="loading-spinner">
    <Loader2 className="animate-spin text-mm-primary" size={32} />
  </div>
);

export const Chip = ({ on, onClick, children, testId }) => (
  <button type="button" data-testid={testId} onClick={onClick} className={`mm-chip ${on ? "mm-chip-on" : ""}`}>
    {children}
  </button>
);

export const RangeField = ({ label, value, onChange, min = 0, max = 10, step = 1, display, testId, left, right }) => (
  <div className="mb-6">
    <div className="flex justify-between items-baseline mb-3">
      <span className="font-semibold">{label}</span>
      <span className="font-display text-xl font-bold text-mm-primary" data-testid={`${testId}-value`}>{display ?? value}</span>
    </div>
    <input type="range" className="mm-range" min={min} max={max} step={step} value={value} data-testid={testId}
      onChange={(e) => onChange(Number(e.target.value))} />
    {(left || right) && (
      <div className="flex justify-between text-xs text-mm-muted mt-2"><span>{left}</span><span>{right}</span></div>
    )}
  </div>
);

export const Empty = ({ emoji = "🌱", title, text, cta, to }) => (
  <div className="mm-card p-10 text-center" data-testid="empty-state">
    <div className="text-5xl mb-3">{emoji}</div>
    <h3 className="text-lg font-semibold">{title}</h3>
    {text && <p className="text-mm-muted text-sm mt-1">{text}</p>}
    {cta && <Link to={to} className="mm-btn mt-5" data-testid="empty-state-cta">{cta}</Link>}
  </div>
);

export const SectionTitle = ({ children, right }) => (
  <div className="flex items-center justify-between mb-3 mt-8">
    <h2 className="text-lg font-semibold">{children}</h2>
    {right}
  </div>
);

export const Tabs = ({ items, value, onChange, testPrefix }) => (
  <div className="flex gap-2 mm-scroll-x pb-2 mb-6">
    {items.map((it) => (
      <Chip key={it.id} on={value === it.id} onClick={() => onChange(it.id)} testId={`${testPrefix}-${String(it.id).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
        {it.icon && <span>{it.icon}</span>}
        <span className="whitespace-nowrap">{it.name}</span>
        {it.tag && <span className="text-[10px] font-bold uppercase tracking-wide rounded-full px-1.5 text-white" style={{ background: "#E8833A" }} data-testid={`${testPrefix}-tag-${String(it.id).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{it.tag}</span>}
        {it.count != null && <span className={`text-[11px] font-semibold rounded-full px-1.5 min-w-[1.25rem] text-center ${value === it.id ? "bg-white/25 text-white" : "bg-mm-primary/10 text-mm-muted"}`} data-testid={`${testPrefix}-count-${String(it.id).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>{it.count}</span>}
      </Chip>
    ))}
  </div>
);
